module.exports = __webpack_public_path__ + "static/media/experience-widget.ffa9acad.svg";